import React from "react";
import ImageMisc, {IconType, IconSize} from "./ImageMisc";
import Tribe from "../../enum/Tribe";

type Props = {
    tribe: Tribe,
    size: IconSize,
}

const tribeIconMap = {
    [Tribe.Roman]: 'roman',
    [Tribe.Teuton]: 'teuton',
    [Tribe.Gaul]: 'gaul',
    [Tribe.Natars]: 'natar',
    [Tribe.Egypt]: 'egyptian',
    [Tribe.Hun]: 'hun',
    [Tribe.Spartan]: 'spartan',
    [Tribe.Viking]: 'viking',
    [Tribe.Nature]: null,
} as Record<Tribe, IconType>;

export function ImageTribe({tribe, size}: Props) {
    if (tribeIconMap[tribe] === null) {
        return null;
    } else {
        return <ImageMisc type={tribeIconMap[tribe]} size={size}/>
    }
}
